import { InfoStoreType } from './storeTypes';

export const InfoDefaultStore: InfoStoreType = {
	loading: false,
	error: false,
	last_updated: null,
	availableCategories: [],
};
